import { useMsal } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import { getAuthType } from "../common/utils/common.fn";

export const useIsLoggedIn = () => {
  const { accounts, inProgress } = useMsal();
  const idToken = localStorage.getItem("idToken");
  const accessToken = localStorage.getItem("accessToken");
  const authType = getAuthType(idToken);

  // If MSAL is still processing, don't return false yet (wait for it to complete)
  const isMsalProcessing = inProgress !== InteractionStatus.None;

  if (authType === "microsoft") {
    // For Microsoft auth, wait for MSAL to finish processing
    if (isMsalProcessing) {
      // If we have accounts or token, likely authenticated, just processing
      return !!(accounts && accounts.length > 0) || !!idToken;
    }
    return accounts && accounts.length > 0;
  }

  if (authType === "manual") {
    return !!idToken || !!accessToken;
  }

  // Fallback: if MSAL is processing and we have accounts, consider logged in
  if (isMsalProcessing && accounts && accounts.length > 0) {
    return true;
  }

  return (accounts && accounts.length > 0) || !!idToken || !!accessToken;
};
